import { Field } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';

const ColorFieldItem = (props) => {
   return (
      <FormGroup
         className='text-center'
      >
         <Label>
            { props.label }
            <Field
               {
                  ...props
               }
            />
         </Label>
      </FormGroup>
   );
};

ColorFieldItem.propTypes = {
   label: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   component: PropTypes.func.isRequired,
};


export default ColorFieldItem;
